import Carousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';

const loadCarouselQuotes = () => {
  // gets the height of each slide
  const readSlideHeights = carousel =>
    carousel.slideNodes().map(slideNode => {
      const slideInner = slideNode.querySelector('*');
      return slideInner.getBoundingClientRect().height;
    });

  // sets the height of the container to height of the current slide and dots
  const adaptContainerToSlide = (carousel, slideHeights) => {
    const currentSlideHeight = slideHeights[carousel.selectedScrollSnap()];
    carousel.containerNode().style.height = `${currentSlideHeight + 76}px`;
  };

  const carouselQuoteNode = document.querySelector('.slo-carousel-quotes');

  if (carouselQuoteNode) {
    const classnameOptions = {
      draggable: 'cursor-grab',
      dragging: 'cursor-grabbing'
    };

    const carousel = Carousel(carouselQuoteNode, {
      loop: false
    }, [ClassNames(classnameOptions)]);

    let slideHeights = [];
    const storeSlideHeights = () => (slideHeights = readSlideHeights(carousel));
    const setContainerHeight = () => adaptContainerToSlide(carousel, slideHeights);

    const onCarouselSelect = () => {
      const index = carousel.selectedScrollSnap();
      carousel.slideNodes().forEach((el, i) => el.classList.toggle('is-active', i === index));
    };

    const setupDotBtns = (dotsArray, embla) => {
      dotsArray.forEach((dotNode, i) => {
        dotNode.addEventListener('click', () => embla.scrollTo(i), false);
      });
    };

    const generateDotBtns = (dots, embla) => {
      const template = document.getElementById('embla-dot-quote').innerHTML;
      dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + template, '');
      return [].slice.call(dots.querySelectorAll('.slo-carousel-quotes--dot'));
    };

    const selectDotBtn = (dotsArray, embla) => () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove('is-selected');
      dotsArray[selected].classList.add('is-selected');
    };

    const dots = document.querySelector('.slo-carousel-quotes--dots');
    const dotsArray = generateDotBtns(dots, carousel);
    const setSelectedDotBtn = selectDotBtn(dotsArray, carousel);

    onCarouselSelect();
    setupDotBtns(dotsArray, carousel);

    carousel.on('select', onCarouselSelect);
    carousel.on('select', setSelectedDotBtn);
    carousel.on('init', setSelectedDotBtn);
    carousel.on('init', storeSlideHeights);
    carousel.on('init', setContainerHeight);
    carousel.on('resize', storeSlideHeights);
    carousel.on('resize', setContainerHeight);
    carousel.on('select', setContainerHeight);
  }
};

export default loadCarouselQuotes;
